import { Box, Divider, Typography } from "@mui/material"
import { Device, DeviceConsumable } from "graphql/types"
import { isDeviceConsumable, isEutGroup } from "store/typeGuards"

type DeviceListProps = {
  devices: Device[]
  onDeviceClick?: (device: Device) => void
}

export const DeviceList = (props: DeviceListProps) => {
  const { devices, onDeviceClick } = props

  return (
    <Box>
      {devices.map((item) => (
        <Box key={item.id}>
          <Box
            onClick={() => onDeviceClick?.(item)}
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 1,
              justifyContent: "space-between",
              cursor: onDeviceClick ? "pointer" : "default",
              "&:hover": onDeviceClick ? {
                backgroundColor: "action.hover",
                borderRadius: 1,
                px: 1,
                mx: -1,
              } : {},
              transition: "background-color 0.2s",
              py: 0.5,
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 1,
              }}
            >
              <Typography variant="body2">
                {isEutGroup(item) ? `${item.barcode}-x` : item.barcode}: {item.name}{" "}
                {isEutGroup(item) ? `(${item.devices.length}x)` : ""}
              </Typography>
            </Box>

            {isDeviceConsumable(item) && (
              <>
                {isDeviceConsumable(item) && (
                  <Box>
                    <Typography variant="body2">
                      Menge: {(item as DeviceConsumable).amount} {(item as DeviceConsumable).unit}
                    </Typography>
                    <Typography variant="body2">
                      Charge: {(item as DeviceConsumable).charge}
                    </Typography>
                  </Box>
                )}
              </>
            )}
          </Box>
        </Box>
      ))}
      <Divider />
    </Box>
  )
}
